'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styles = require('@material-ui/core/styles');

var _Grid = require('@material-ui/core/Grid');

var _Grid2 = _interopRequireDefault(_Grid);

var _Typography = require('@material-ui/core/Typography');

var _Typography2 = _interopRequireDefault(_Typography);

var _Button = require('@material-ui/core/Button');

var _Button2 = _interopRequireDefault(_Button);

var _styles2 = require('./styles');

var _styles3 = _interopRequireDefault(_styles2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BasicFooter = function (_React$PureComponent) {
  _inherits(BasicFooter, _React$PureComponent);

  function BasicFooter() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, BasicFooter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BasicFooter.__proto__ || Object.getPrototypeOf(BasicFooter)).call.apply(_ref, [this].concat(args))), _this), _this.renderLogo = function () {
      var _this$props = _this.props,
          classes = _this$props.classes,
          title = _this$props.title,
          logo = _this$props.logo;

      if (logo) {
        return _react2.default.createElement('img', { src: logo, alt: title, className: classes.logoImage });
      }
      return _react2.default.createElement(
        _Typography2.default,
        { variant: 'title', color: 'inherit', className: classes.flex },
        title
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(BasicFooter, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          title = _props.title,
          classes = _props.classes,
          smallMessage = _props.smallMessage,
          bigMessage = _props.bigMessage,
          links = _props.links;

      return _react2.default.createElement(
        _Grid2.default,
        { container: true, alignItems: 'flex-end', justify: 'space-around', spacing: 16 },
        _react2.default.createElement(
          _Grid2.default,
          { item: true, xs: 12 },
          _react2.default.createElement(
            'div',
            { className: classes.message },
            _react2.default.createElement(
              _Typography2.default,
              { variant: 'display3', color: 'inherit' },
              bigMessage
            )
          )
        ),
        _react2.default.createElement(
          _Grid2.default,
          { item: true, xs: 12, md: 4 },
          _react2.default.createElement(
            _Grid2.default,
            { container: true, direction: 'row', spacing: 0, justify: 'center' },
            _lodash2.default.map(links, function (link) {
              return _react2.default.createElement(
                _Button2.default,
                { href: link.href, color: 'inherit', key: link.label },
                link.label
              );
            })
          )
        ),
        _react2.default.createElement(
          _Grid2.default,
          { item: true, xs: 12, md: 4 },
          _react2.default.createElement(
            _Grid2.default,
            { container: true, direction: 'column', alignItems: 'center', spacing: 0 },
            _react2.default.createElement(
              _Typography2.default,
              { variant: 'body1', color: 'inherit' },
              smallMessage
            ),
            _react2.default.createElement(
              _Typography2.default,
              { variant: 'caption', color: 'inherit' },
              title,
              ' \xA9 ',
              new Date().getFullYear()
            )
          )
        ),
        _react2.default.createElement(
          _Grid2.default,
          { item: true, xs: 12, md: 4 },
          _react2.default.createElement(
            _Grid2.default,
            { container: true, justify: 'center' },
            this.renderLogo()
          )
        )
      );
    }
  }]);

  return BasicFooter;
}(_react2.default.PureComponent);

BasicFooter.defaultProps = {
  title: 'Brand'
};
exports.default = (0, _styles.withStyles)(_styles3.default)(BasicFooter);


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-layout/lib/templates/Footer/BasicFooter/BasicFooter.js
// module id = 629
// module chunks = 61549186969478 79611799117203